import React from "react";
import bodyHelperTypes from "../../../utils/BodyHelperTypes";
import Links from "../../../components/Links";

const eCMHLinks_Content = [
    
    {
        format: bodyHelperTypes.title,
        order: 10,
        content: "Kentucky Resources"

    },
    {
        format: bodyHelperTypes.paragraph,
        order: 20,
        content: <><Links linkTypeID="5" /></>

    },
    {
        format: bodyHelperTypes.title,
        order: 30,
        content: "National Resources"

    },
    {
        format: bodyHelperTypes.paragraph,
        order: 40,
        content: <><Links linkTypeID="6" /></>

    },
    



            

           
    


];

export default eCMHLinks_Content;